// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const industryUpdateInDescriptionOneMax = 2000;

export const industryUpdateInNameOneMax = 120;

export const IndustryUpdateIn = zod.object({
  "description": zod.union([zod.string().max(industryUpdateInDescriptionOneMax),zod.null()]).optional(),
  "is_active": zod.union([zod.boolean(),zod.null()]).optional(),
  "name": zod.union([zod.string().min(1).max(industryUpdateInNameOneMax),zod.null()]).optional()
});

export type IndustryUpdateIn = zod.input<typeof IndustryUpdateIn>;
export type IndustryUpdateInOutput = zod.output<typeof IndustryUpdateIn>;
